import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height:100% removido pra deixar o Container assumir tamanho natural;
     o scroll fica no SidebarBody (pai). Antes Container tinha height:100%
     + overflow:hidden e AppsGrid tinha proprio overflow-y:auto — scroll
     duplicado, scrollbar interna do AppsGrid sobrepondo a borda direita
     dos cards. */
`;

// Grid de cards: CSS Grid com auto-fill, minmax(190px, 1fr) distribui
// N cards por linha conforme largura disponivel sem deixar buracos.
// Sem overflow proprio — quem rola e o SidebarBody do customer.
export const AppsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 12px;
  align-content: flex-start;
  width: 100%;
  padding: 4px;
`;

export const Line = styled.div`
  display: flex;
  flex: ${(props) => props.flex};
  justify-content: ${(props) => props.justify || 'flex-start'};
  align-items: center;
  gap: 8px;
  ${(props) => props.width && `width: ${props.width};`};
  ${(props) => props.margin && `margin: ${props.margin};`};
`;

export const Title = styled.span`
  display: block;
  margin-top: 8px;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.label};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Tag = styled.div`
  min-width: ${(props) => (props.closed ? '35px' : '0')};
  flex: 0 1 auto;
  height: ${(props) => (props.closed ? '10px' : '18px')};
  background: ${(props) =>
    props.selected ? props.color : props.theme.colors.card};
  color: ${(props) =>
    props.selected || props.filter === ''
      ? props.theme.colors.white
      : props.color};
  border-radius: 8px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 8px;
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.3s;
  border: ${(props) => `1px solid ${props.color}`};
  white-space: nowrap;
  label {
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    white-space: nowrap;
  }
  ${(props) =>
    props.filter === '' &&
    `background: ${props.color}; color: ${props.theme.colors.white}`};
  @media (max-width: 844px) {
    height: ${(props) => props.filtering && '12px'};
    label {
      display: ${(props) => props.filtering && 'none'};
    }
  }

  ${(props) =>
    props.clickable &&
    `:hover {
    color: ${props.color};
    background: ${props.theme.colors.white};
  }`}
`;

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 240px;
  padding: 10px 10px 12px;
  gap: 6px;
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme.colors.lightblue
        : props.theme.colors.disabled};
  /* Box-shadow combina o sombreado de profundidade padrao + halo
     azul-claro quando selected. O halo (3px outer ring) e mais
     visivel que so trocar a cor da border, sem ficar agressivo. */
  /* Superficie do card: nao mais transparente — usa a cor de card do
     tema pra ter corpo proprio sobre o fundo do sidebar (antes os
     cards "sumiam" como so-borda). Selected ganha tint cyan por cima.
     Sombra suave theme-aware da profundidade sem pesar no light. */
  box-shadow: ${(props) =>
    props.theme.title === 'light'
      ? '0 1px 3px rgba(15, 23, 42, 0.06)'
      : '0 1px 3px rgba(0, 0, 0, 0.35)'};
  background: ${(props) =>
    props.selected
      ? props.theme.title === 'light'
        ? 'rgba(59, 191, 241, 0.08)'
        : 'rgba(59, 191, 241, 0.10)'
      : props.theme.colors.card};
  box-sizing: border-box;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  transition: border-color 180ms ease, box-shadow 180ms ease,
    background 180ms ease, transform 180ms ease;

  /* Hover: leve lift + border lightblue (so quando clickable e nao
     ja selected — selected ja tem feedback visual proprio). */
  ${(props) =>
    props.clickable &&
    !props.selected &&
    `
      &:hover {
        border-color: ${props.theme.colors.lightblue};
        transform: translateY(-1px);
        box-shadow: ${
          props.theme.title === 'light'
            ? '0 4px 12px rgba(15, 23, 42, 0.1)'
            : '0 4px 12px rgba(0, 0, 0, 0.45)'
        };
      }
    `}
`;

// Indicador de freshness inline: dot pulsante embutido dentro da Tag
// de status (RODANDO/ALARME/etc), ao lado do texto. Antes era um pill
// absolute no canto que sobrepunha a propria Tag — visualmente confuso.
// Agora a Tag ja serve como label de status; o dot verde pulsante so
// adiciona a info "live" (dados recentes) sem competir por espaco.
//   Verde pulsando = update <60s atras
//   Branco semi-transparente = stale ou ainda sem dado
export const FreshnessDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  /* O dot fica DENTRO da Tag de status (fundo saturado: cinza/verde/
     vermelho), nao sobre a superficie do card — entao branco-translucido
     funciona nos dois temas (contraste sobre cor saturada). */
  background: ${(props) =>
    props.$live
      ? props.theme.colors.green || '#2ecc71'
      : 'rgba(255, 255, 255, 0.45)'};
  flex-shrink: 0;
  margin-right: 4px;
  box-shadow: 0 0 0 0
    ${(props) => props.theme.colors.green || '#2ecc71'};
  ${(props) =>
    props.$live &&
    `animation: card-fresh-pulse 1.8s ease-out infinite;`}

  @keyframes card-fresh-pulse {
    0% {
      box-shadow: none;
    }
    70% {
      box-shadow: none;
    }
    100% {
      box-shadow: none;
    }
  }
`;

export const Breakdown = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 0 2px;
`;

export const BreakdownChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border-radius: 6px;
  /* surfaceMuted (nao a cor card): agora que o card tem fundo solido,
     os chips precisam de um tom diferente pra destacar da superficie. */
  background: ${(props) => props.theme.colors.surfaceMuted};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  font-size: 10px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkerblue};
  font-variant-numeric: tabular-nums;
`;

// Subtitulo abaixo da Label principal: "3 TGAs" / "1 BOMBA". Cor accent
// segue o tipo (laranja=UCHA, azul=EBA) pra reforcar associacao visual
// padronizada do sistema.
export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background: ${(props) =>
    props.theme.title === 'light'
      ? `${props.color}1A`
      : `${props.color}26`};
  border: 1px solid ${(props) => `${props.color}66`};
  color: ${(props) => props.color};
  font-variant-numeric: tabular-nums;
`;

// Linha de metricas realtime no card (potencia, vazao). Mostrada apenas
// quando ha dados frescos via state.iot[thingName].values. Visual
// minimalista: pares de [icone][valor + unidade].
export const Metrics = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 2px 4px;
  font-variant-numeric: tabular-nums;
`;

export const Metric = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.darkerblue};

  > svg {
    width: 12px;
    height: 12px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    color: ${(props) => props.color || props.theme.colors.label};
    flex-shrink: 0;
  }

  small {
    font-size: 9px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.label};
    margin-left: 1px;
  }
`;

export const BreakdownDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
`;

export const CardImage = styled.img`
  max-height: 80px;
  width: 90px;
  object-fit: contain;
  margin: 2px 0;
`;

export const CardButton = styled.button`
  width: 100%;
  padding: 6px 12px;
  margin-top: auto;
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  outline: none;
  color: ${(props) => props.theme.colors.lightblue};
  font-weight: bold;
  font-size: 12px;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: 270ms all;
  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const Label = styled.label`
  color: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.darkerblue
      : props.theme.colors.label};
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  line-height: 1.25;
  padding: 0 2px;
  word-break: break-word;
`;

export const NoApplicationMessage = styled.label`
  font-size: 14px;
  font-style: italic;
  color: ${(props) => props.theme.colors.label};
  grid-column: 1 / -1;
  text-align: center;
  padding: 24px 0;
`;
